<div id="brand-overlay"></div>
<div id="branded"></div>

<div class="d-flex align-items-center auth px-0 yettel-container">
    <div class="row w-100 mx-0">
        <div class="col-12 col-lg-10 col-xl-6 mx-auto">
            <div id="not-auth-modal" class="text-left py-5 px-4 px-sm-5">
                <div class="brand-logo">
                    <a routerLink="../login">
                        <img src="assets/images/logo.svg" alt="agaia logo">
                    </a>
                </div>
                <div class="heading-text">
                    <h4>{{ 'auth_register_title' | localise }}</h4>
                    <h6 class="font-weight-light">{{ 'auth_register_text' | localise }}</h6>
                </div>
                <form id="search" name="lastpass-disable-search" class="pt-3" autocomplete="off"
                      [formGroup]="registerForm">
                    <div #step1Group
                         [class.form-group]="!(registerForm.controls['email'].dirty && !registerForm.controls['email'].valid)">
                        <input #email
                               autocomplete="off"
                               type="email"
                               data-lpignore="true"
                               class="form-control form-control-lg"
                               [placeholder]="'auth_email' | localise"
                               formControlName="email"
                               [inputValidation]="{
                condition: registerForm.controls['email'].dirty && !registerForm.controls['email'].valid,
                error: 'auth_err_invalid_email' | localise
              }">
                    </div>

                    <div [class.form-group]="!(registerForm.controls['password'].dirty && !registerForm.controls['password'].valid)">
                        <input #password
                               autocomplete="off"
                               type="password"
                               data-lpignore="true"
                               class="form-control form-control-lg"
                               [placeholder]="'auth_password' | localise"
                               formControlName="password"
                               [inputValidation]="{
                condition: registerForm.controls['password'].dirty && !registerForm.controls['password'].valid,
                error: password.value.length < 5 ? ('auth_err_password_too_short' | localise) : ('auth_err_enter_a_password' | localise)
              }">
                    </div>

                    <div [class.form-group]="!(registerForm.controls['yettel_token'].dirty && !registerForm.controls['yettel_token'].valid)">
                        <input #yettelToken
                               autocomplete="off"
                               type="text"
                               data-lpignore="true"
                               class="form-control form-control-lg"
                               [placeholder]="'Yettel Код'"
                               formControlName="yettel_token"
                               [inputValidation]="{
                condition: registerForm.controls['yettel_token'].dirty && !registerForm.controls['yettel_token'].valid,
                error: yettelToken.value.length < 5 ? 'Въведения код е прекалено кратък.' : 'Моля въведете код.'
              }">
                    </div>

                    <div class="mb-4">
                        <div class="form-check">
                            <label class="form-check-label text-muted">
                                <input type="checkbox" class="form-check-input"
                                       (input)="userHasAgreedToTermsAndConditions = !userHasAgreedToTermsAndConditions">
                                <i class="input-helper"></i>
                                <span>{{ 'agree_to_the' | localise }}</span>
                                <span class="text-primary" style="cursor: pointer;"
                                      (click)="openTermsAndConditions($event)"> {{ 'terms_and_conditions' | localise }}</span>
                            </label>
                        </div>
                        <div class="form-check">
                            <label class="form-check-label text-muted">
                                <input type="checkbox" class="form-check-input"
                                       (input)="over18 = !over18">
                                <i class="input-helper"></i>
                                <span>{{ 'im_over_18' | localise }}</span>
                            </label>
                        </div>
                    </div>

                    <div #registerButton class="mt-3">
                        <button class="yettel-signup btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                                (click)="onSignUp()"
                                [disabled]="!registerForm.valid  || !userHasAgreedToTermsAndConditions || !over18">{{ 'auth_sign_up' | localise }}
                        </button>
                    </div>
                </form>

                <div style="text-align: center;cursor: pointer;margin-top: 20px;">
                    <a class="nav-link dropdown-toggle" [app-popup]="{
              templateRef: languagesPopupTemplate,
              position: 'top',
              arrowPosition: ['top', 'center'],
              paddingless: true,
              closeUponSelection: true
            }">
                        <i class="ti-world mx-0"></i>
                        {{ 'change_language' | localise }}
                    </a>
                </div>

                <ng-template #languagesPopupTemplate>
                    <a class="dropdown-item preview-item" *ngFor="let language of languages"
                       (click)="onLanguageSelected(language)">
                        <div class="preview-thumbnail">
                            <div class="responsive-flex-wrapper">
                                <i [ngClass]="'m-0 flag-icon flag-icon-' + flagIcon(language)"></i>
                            </div>
                        </div>
                        <div class="preview-item-content">{{ language | localise }}</div>
                    </a>
                </ng-template>
            </div>

            <div id="stores">
                <div class="yettel-logo">
                    <img src="assets/images/yettel-logo.png" height="42"/>
                </div>
            </div>
        </div>
    </div>
</div>
